"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

var _autosuggestHighlight = _interopRequireDefault(require("autosuggest-highlight"));

var _underscore = _interopRequireDefault(require("underscore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function containsUnicode(str) {
  // eslint-disable-next-line no-control-regex
  return /[^\u0000-\u00ff]/.test(str);
}

function getSuggestions(people, value) {
  var escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  var regex = !containsUnicode(escapedValue) ? new RegExp('\\b' + escapedValue, 'i') : new RegExp(escapedValue, 'iu');
  return people.filter(function (person) {
    return regex.test(getSuggestionValue(person));
  });
}

function getSuggestionValue(suggestion) {
  suggestion.firstName = suggestion.firstName || '';
  suggestion.lastName = suggestion.lastName || '';
  return "".concat(suggestion.firstName, " ").concat(suggestion.lastName);
}

function renderSuggestion(suggestion, _ref) {
  var query = _ref.query;
  var suggestionText = "".concat(suggestion.firstName, " ").concat(suggestion.lastName);

  var matches = _autosuggestHighlight.default.match(suggestionText, query);

  var parts = _autosuggestHighlight.default.parse(suggestionText, matches);

  var thumbnailUrl = suggestion.thumbnailUrl ? suggestion.thumbnailUrl : '/images/avatar.png';
  return /*#__PURE__*/_react.default.createElement("span", {
    className: 'suggestion-content'
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "autocomplete-img",
    src: thumbnailUrl
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "name ellipsis"
  }, parts.map(function (part, index) {
    var className = part.highlight ? 'highlight' : null;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: className,
      key: index
    }, part.text);
  })));
}

var AutoSuggest = /*#__PURE__*/function (_Component) {
  _inherits(AutoSuggest, _Component);

  var _super = _createSuper(AutoSuggest);

  function AutoSuggest() {
    var _this;

    _classCallCheck(this, AutoSuggest);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "initialState", {
      value: '',
      suggestions: _this.props.suggestions,
      isLoading: false,
      immediate: false
    });

    _defineProperty(_assertThisInitialized(_this), "state", _this.initialState);

    _defineProperty(_assertThisInitialized(_this), "loadSuggestionsDebounce", _underscore.default.debounce(function (value) {
      _this.loadSuggestions(value);
    }, 300, _this.props.immediate));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event, _ref2) {
      var newValue = _ref2.newValue;

      _this.setState({
        value: newValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsFetchRequested", function (_ref3) {
      var value = _ref3.value;

      _this.loadSuggestionsDebounce(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionsClearRequested", function () {
      _this.setState({
        suggestions: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSuggestionSelected", function (event, suggestionSelectedObject) {
      var _this$props = _this.props,
          onSuggestionSelected = _this$props.onSuggestionSelected,
          autoCleanAfterSelect = _this$props.autoCleanAfterSelect;
      onSuggestionSelected && onSuggestionSelected(event, suggestionSelectedObject);
      autoCleanAfterSelect && _this.setState({
        value: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSuggestionValue", function (suggestion) {
      return _this.props.getSuggestionValue ? _this.props.getSuggestionValue(suggestion) : getSuggestionValue(suggestion);
    });

    _defineProperty(_assertThisInitialized(_this), "getSuggestions", function (response, value) {
      return _this.props.getSuggestions ? _this.props.getSuggestions(response, value) : getSuggestions(response, value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSuggestion", function (suggestion, query) {
      return _this.props.renderSuggestion ? _this.props.renderSuggestion(suggestion, query) : renderSuggestion(suggestion, query);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSectionTitle", function (section) {
      return _this.props.renderSectionTitle ? _this.props.renderSectionTitle(section) : /*#__PURE__*/_react.default.createElement("strong", null, section.title);
    });

    _defineProperty(_assertThisInitialized(_this), "getSectionSuggestions", function (section) {
      return _this.props.getSectionSuggestions ? _this.props.getSectionSuggestions(section) : section.items;
    });

    return _this;
  }

  _createClass(AutoSuggest, [{
    key: "loadSuggestions",
    value: function () {
      var _loadSuggestions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context.next = 3;
                return this.props.fetchSuggestions(value);

              case 3:
                response = _context.sent;
                this.setState({
                  isLoading: false,
                  suggestions: this.getSuggestions(response, value)
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadSuggestions(_x) {
        return _loadSuggestions.apply(this, arguments);
      }

      return loadSuggestions;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          value = _this$state.value,
          isLoading = _this$state.isLoading;
      var multiSection = this.props.multiSection;

      var getSuggestions = function getSuggestions() {
        var suggestionsProps = _this2.props.suggestions;

        if (suggestionsProps && suggestionsProps.length) {
          return suggestionsProps;
        }

        var suggestions = _this2.state.suggestions;
        return suggestions;
      };

      var inputProps = {
        placeholder: this.props.placeholder || 'Type a contact',
        value: value,
        onChange: this.onChange,
        onBlur: this.props.onBlur
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "make-relative"
      }, isLoading && /*#__PURE__*/_react.default.createElement("div", {
        className: "spinner-container"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-spinner fa-spin"
      })), /*#__PURE__*/_react.default.createElement(_reactAutosuggest.default, {
        multiSection: multiSection,
        suggestions: getSuggestions(),
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        getSuggestionValue: this.getSuggestionValue,
        renderSuggestion: this.renderSuggestion,
        onSuggestionSelected: this.onSuggestionSelected,
        inputProps: inputProps,
        renderSectionTitle: this.renderSectionTitle,
        getSectionSuggestions: this.getSectionSuggestions,
        theme: {
          input: 'form-control react-autosuggest__input',
          container: 'react-autosuggest__container',
          containerOpen: 'react-autosuggest__container--open',
          suggestionsContainer: 'react-autosuggest__suggestions-container',
          suggestionsList: 'react-autosuggest__suggestions-list',
          suggestion: 'react-autosuggest__suggestion',
          suggestionFocused: 'react-autosuggest__suggestion--focused',
          sectionContainer: 'react-autosuggest__section-container',
          sectionTitle: 'react-autosuggest__section-title'
        }
      }));
    }
  }]);

  return AutoSuggest;
}(_react.Component);

_defineProperty(AutoSuggest, "defaultProps", {
  value: '',
  suggestions: [],
  isLoading: false,
  immediate: false
});

var BZAutosuggest = /*#__PURE__*/function (_Component2) {
  _inherits(BZAutosuggest, _Component2);

  var _super2 = _createSuper(BZAutosuggest);

  function BZAutosuggest() {
    _classCallCheck(this, BZAutosuggest);

    return _super2.apply(this, arguments);
  }

  _createClass(BZAutosuggest, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          cls = _this$props2.cls;
      var autosuggestClass = (0, _classnames2.default)('bz-autosuggest bz-component', _defineProperty({}, cls, cls));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: autosuggestClass
      }, label && /*#__PURE__*/_react.default.createElement("label", null, label), /*#__PURE__*/_react.default.createElement(AutoSuggest, this.props));
    }
  }]);

  return BZAutosuggest;
}(_react.Component);

_defineProperty(BZAutosuggest, "propTypes", {
  keyName: _propTypes.default.string,
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  fetchSuggestions: _propTypes.default.func,
  onSuggestionSelected: _propTypes.default.func,
  autoCleanAfterSelect: _propTypes.default.bool,
  immediate: _propTypes.default.bool,
  multiSection: _propTypes.default.bool,
  suggestions: _propTypes.default.arrayOf(_propTypes.default.object)
});

var _default = BZAutosuggest;
exports.default = _default;